import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import Select from "react-select";

function InspAdmissionChallanModal({ open, onClose, student }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const currentDate = new Date().toISOString().split("T")[0];

  const feeOptions = [
    { value: "Computer Fee", label: "Computer Fee" },
    { value: "Other Fee", label: "Other Fee" },
    { value: "Library Fee", label: "Library Fee" },
    { value: "Sports Fee", label: "Sports Fee" },
  ];

  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: {
      dueDate: "",
      amount1: "",
      amount2: "",
      additionalHead1: null,
      additionalHead2: null,
    },
  });

  useEffect(() => {
    reset();
  }, [reset]);

  const handleGenerate = async (data) => {
    setIsSubmitting(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      toast.success("Challan generated successfully!");
      onClose();
    } catch (error) {
      toast.error("Error generating challan");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!open) return null;

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
        onClick={handleBackdropClick}
      >
        <div
          className="modal-dialog"
          style={{
            maxWidth: "600px",
            marginTop: "20px",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="modal-content"
            style={{
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="modal-header" style={{ padding: "12px 16px" }}>
              <h5 className="mb-0 fw-bold">Admission Challan</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body" style={{ padding: "16px" }}>
              <form onSubmit={handleSubmit(handleGenerate)}>
                <div className="row g-2">
                  {/* Left Column */}
                  <div className="col-md-6">
                    {/* Student Full Name */}
                    <div className="mb-2">
                      <label className="form-label fw-semibold">
                        Student Full Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={
                          student?.studentFullName ||
                          student?.studentName ||
                          "N/A"
                        }
                        disabled
                        style={{
                          backgroundColor: "#f8f9fa",
                          height: "38px", // Explicit height to match dropdowns
                        }}
                      />
                    </div>

                    {/* Head */}
                    <div className="mb-2">
                      <label className="form-label fw-semibold">Head</label>
                      <input
                        type="text"
                        className="form-control"
                        value="Tuition Fee"
                        disabled
                        style={{
                          backgroundColor: "#f8f9fa",
                          height: "38px",
                        }}
                      />
                    </div>

                    {/* Additional Head 1 */}
                    <div className="mb-2">
                      <label className="form-label fw-semibold">
                        {/* Additional Head 1 */}
                      </label>
                      <Controller
                        name="additionalHead1"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={feeOptions}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption);
                            }}
                            onBlur={field.onBlur}
                            value={field.value}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            isClearable
                            placeholder="Select Additional Head"
                            styles={{
                              control: (base) => ({
                                ...base,
                                height: "38px",
                                minHeight: "38px",
                                fontSize: "0.75rem",
                                borderRadius: "0.25rem",
                                border: "1px solid #ced4da",
                                padding: "0",
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                padding: "0 0.75rem",
                                height: "38px",
                                display: "flex",
                                alignItems: "center",
                              }),
                              singleValue: (base) => ({
                                ...base,
                                lineHeight: "38px",
                              }),
                              input: (base) => ({
                                ...base,
                                margin: 0,
                                padding: 0,
                                lineHeight: "38px",
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                padding: "0 0.5rem",
                              }),
                              clearIndicator: (base) => ({
                                ...base,
                                padding: "0 0.5rem",
                              }),
                            }}
                          />
                        )}
                      />
                    </div>

                    {/* Additional Head 2 */}
                    <div className="mb-2">
                      <label className="form-label fw-semibold">
                        {/* Additional Head 2 */}
                      </label>
                      <Controller
                        name="additionalHead2"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={feeOptions}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption);
                            }}
                            onBlur={field.onBlur}
                            value={field.value}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            isClearable
                            placeholder="Select Additional Head"
                            styles={{
                              control: (base) => ({
                                ...base,
                                height: "38px",
                                minHeight: "38px",
                                fontSize: "0.75rem",
                                borderRadius: "0.25rem",
                                border: "1px solid #ced4da",
                                padding: "0",
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                padding: "0 0.75rem",
                                height: "38px",
                                display: "flex",
                                alignItems: "center",
                              }),
                              singleValue: (base) => ({
                                ...base,
                                lineHeight: "38px",
                              }),
                              input: (base) => ({
                                ...base,
                                margin: 0,
                                padding: 0,
                                lineHeight: "38px",
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                padding: "0 0.5rem",
                              }),
                              clearIndicator: (base) => ({
                                ...base,
                                padding: "0 0.5rem",
                              }),
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="col-md-6">
                    {/* Class */}
                    <div className="mb-2">
                      <label className="form-label fw-semibold">Class</label>
                      <input
                        type="text"
                        className="form-control"
                        value={student?.className || "N/A"}
                        disabled
                        style={{
                          backgroundColor: "#f8f9fa",
                          height: "38px",
                        }}
                      />
                    </div>

                    {/* Amount */}
                    <div className="mb-2">
                      <label className="form-label fw-semibold">Amount</label>
                      <input
                        type="text"
                        className="form-control"
                        value="4650"
                        disabled
                        style={{
                          backgroundColor: "#f8f9fa",
                          height: "38px",
                        }}
                      />
                    </div>

                    {/* Amount for Additional Head 1 */}
                    <div className="mb-2">
                      <label className="form-label fw-semibold">
                        {/* Amount for Additional Head 1 */}
                      </label>
                      <input
                        type="number"
                        {...register("amount1", {
                          min: {
                            value: 0,
                            message: "Amount cannot be negative",
                          },
                        })}
                        className={`form-control ${
                          errors.amount1 ? "is-invalid" : ""
                        }`}
                        placeholder="Enter amount"
                        style={{ height: "38px" }}
                      />
                      {errors.amount1 && (
                        <div className="invalid-feedback">
                          {errors.amount1.message}
                        </div>
                      )}
                    </div>

                    {/* Amount for Additional Head 2 */}
                    <div className="mb-2">
                      <label className="form-label fw-semibold">
                        {/* Amount for Additional Head 2 */}
                      </label>
                      <input
                        type="number"
                        {...register("amount2", {
                          min: {
                            value: 0,
                            message: "Amount cannot be negative",
                          },
                        })}
                        className={`form-control ${
                          errors.amount2 ? "is-invalid" : ""
                        }`}
                        placeholder="Enter amount"
                        style={{ height: "38px" }}
                      />
                      {errors.amount2 && (
                        <div className="invalid-feedback">
                          {errors.amount2.message}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Due Date and Created Date in Same Row */}
                  <div className="col-12">
                    <div className="row g-2">
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          Due Date<span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          {...register("dueDate", {
                            required: "Due date is required",
                          })}
                          className={`form-control ${
                            errors.dueDate ? "is-invalid" : ""
                          }`}
                          style={{ height: "38px" }}
                        />
                        {errors.dueDate && (
                          <div className="invalid-feedback">
                            {errors.dueDate.message}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          Created Date
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={currentDate}
                          disabled
                          style={{
                            backgroundColor: "#f8f9fa",
                            color: "black",
                            fontWeight: "bold",
                            height: "38px",
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="col-12">
                    <div className="d-flex gap-2 justify-content-end pt-2 border-top">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={onClose}
                        disabled={isSubmitting}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary btn-sm"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              aria-hidden="true"
                            ></span>
                            Generating...
                          </>
                        ) : (
                          "Generate"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" onClick={onClose}></div>
    </>
  );
}

export default InspAdmissionChallanModal;
